import {
  TASK_WITHDRAW_LOADED,
  TASK_WITHDRAW_NEXT_PAGE_LOADED,
  TASK_WITHDRAW_UNLOADED,
  TASK_DEPOSIT_LOADED,
  TASK_DEPOSIT_NEXT_PAGE_LOADED,
  TASK_COMPLETE,
  TASK_DEPOSIT_UNLOADED,
  TASK_VERIFICATION_LOADED,
  TASK_VERIFICATION_NEXT_PAGE_LOADED,
  TASK_VERIFICATION_UNLOADED,
  TASK_KYC_LOADED,
  TASK_KYC_NEXT_PAGE_LOADED,
  TASK_KYC_UNLOADED,
  TASK_VERIFICATION_EXPORT,
  UPDATE_FIELD_TASK_SEARCHTERM,
  TASK_WITHDRAW_SEARCH_LOADED,
  TASK_DEPOSIT_SEARCH_LOADED,
  TASK_VERIFICATION_SEARCH_LOADED,
  TASK_KYC_SEARCH_LOADED,
  USER_TASK_LIST_LOADED,
  USER_TASK_LIST_UNLOADED,
  TASK_WITHDRAW_EXPORT,
  DEPOSIT_FILE_UPLOADED,
  TASK_GEMINIORDERS_LOADED,
  TASK_GEMINIORDERS_NEXT_PAGE_LOADED,
  TASK_GEMINIORDERS_UNLOADED,
  TASK_GEMINIORDERS_EXPORT,
  TASK_GEMINIORDERS_SEARCH_LOADED,
} from '../constants/actionTypes'
import { PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
  switch (action.type) {
    case TASK_DEPOSIT_LOADED:
    case TASK_DEPOSIT_SEARCH_LOADED:
    case TASK_DEPOSIT_NEXT_PAGE_LOADED:
      return {
        ...state,
        deposits: action.payload.tasks,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
        status: action.status,
        csvData: null
      }
    case TASK_WITHDRAW_LOADED:
    case TASK_WITHDRAW_SEARCH_LOADED:
    case TASK_WITHDRAW_NEXT_PAGE_LOADED:
      return {
        ...state,
        withdraws: action.payload.tasks,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
        status: action.status,
        csvData: null
      }
    case TASK_VERIFICATION_LOADED:
    case TASK_VERIFICATION_SEARCH_LOADED:
    case TASK_VERIFICATION_NEXT_PAGE_LOADED:
      return {
        ...state,
        verifications: action.payload.tasks,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
        status: action.status,
        csvData: null
      }
    case TASK_KYC_LOADED:
    case TASK_KYC_SEARCH_LOADED:
    case TASK_KYC_NEXT_PAGE_LOADED:
      return {
        ...state,
        kyc: action.payload.tasks,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
        status: action.status,
        csvData: null
      }
    case TASK_GEMINIORDERS_LOADED:
    case TASK_GEMINIORDERS_SEARCH_LOADED:
    case TASK_GEMINIORDERS_NEXT_PAGE_LOADED:
      return {
        ...state,
        orders: action.payload.tasks,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
        status: action.status,
        csvData: null
      }
    case TASK_COMPLETE:
      const id = action.taskId
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        deposits: state.deposits ? state.deposits.filter(task => task.key !== id) : [],
        withdraws: state.withdraws ? state.withdraws.filter(task => task.key !== id) : [],
        verifications: state.verifications ? state.verifications.filter(task => task.key !== id) : [],
        kyc: state.kyc ? state.kyc.filter(task => task.key !== id) : [],
        user_tasks: state.user_tasks ? state.user_tasks.filter(task => task.key !== id) : [],
        csvData: null
      };
    case USER_TASK_LIST_LOADED:
      return {
        ...state,
        user_tasks: action.payload.tasks,
        user: action.payload.user,
        csvData: null
      }
    case TASK_DEPOSIT_UNLOADED:
    case TASK_WITHDRAW_UNLOADED:
    case TASK_VERIFICATION_UNLOADED:
    case TASK_KYC_UNLOADED:
    case USER_TASK_LIST_UNLOADED:
    case TASK_GEMINIORDERS_UNLOADED:
      return {}
    case TASK_VERIFICATION_EXPORT:
    case TASK_WITHDRAW_EXPORT:
    case TASK_GEMINIORDERS_EXPORT:
      return {
        ...state,
        csvData: action.payload
      }
    case UPDATE_FIELD_TASK_SEARCHTERM:
      return {
        ...state,
        [action.key]: action.value,
      }
    case DEPOSIT_FILE_UPLOADED:
      return {
        ...state,
        upload_response_received: action.payload ? true : false,
        upload_response: action.payload,
        csvData: null
      }
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/task.js